import React, { useState, useRef, useEffect} from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import './shapp_p1.css';
import './software.css';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { geometrieConfig } from "./components_software/tipologia_punte_cpt";
import { MapComponent_sw} from './components/MapComponent_sw';
import { viewCPTUReport } from './components_software/view_CPTUE';
import { viewCPTReport } from './components_software/view_CPT';
import { viewLIQUEReport } from './components_software/view_LIQUE';


function CptElabPanel() {
    const navigate = useNavigate();
     // ricezione dati da dataabase per modifica geometria esistente
    const location = useLocation();
    const incomingData = location.state;
    //compoenente mappa per archiviazione
    const mapRef = useRef(null);
    const [isMapClickActive, setIsMapClickActive] = useState(false);
    const toggleMapClick = () => {setIsMapClickActive(prev => !prev);};
    const handleProjectChange = (e) => {
        setSelectedProject(e.target.value);
        mapRef.current?.handleProjectChange(e);  // chiama MapComponent
      };
    // Ottieni i progetti quando il componente si monta
    useEffect(() => {
      const loadProjects = async () => {
        if (mapRef.current) {
          try {
            const projs = await mapRef.current.fetchProjects();
            setProjects(projs); // aggiorna la lista dei progetti
          } catch (err) {
            console.error("Errore caricamento progetti:", err);
          }
        }
      };
      // Polling finché mapRef.current non è pronto
      const interval = setInterval(() => {
        if (mapRef.current) {
          loadProjects();
          clearInterval(interval);
        }
      }, 100);
      return () => clearInterval(interval);
    }, []);
    
    const [projects, setProjects] = useState([]);
    const [selectedProject, setSelectedProject] = useState('');
    //riceve coordinate
    const [coordinate, setCoordinate] = useState("");
    const handleReceiveCoordinate = (coord) => {
        setCoordinate(coord); // aggiorna campo input solo al submit
      };
    // Stati principali
    const [selectedMenu, setSelectedMenu] = useState('anagrafica');
    const [activePanel, setActivePanel] = useState("report");

    const fileInputRef = useRef(null);
    const [magnitude, setMagnitude] = useState('');
    const [taskId, setTaskId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingelab, setLoadingelab] = useState(false);
    const [result, setResult] = useState(null);
    //input data
    const [tipoProva, setTipoProva] = useState("CPTU");
    const [geometria, setGeometria] = useState("Tp");
    const [parametri, setParametri] = useState({});
    //gestione caricamento file prova
    const [rawData, setRawData] = useState([]);
    const [showMapping, setShowMapping] = useState(false);
    const [columnFields, setColumnFields] = useState([]);
    const [columnUnits, setColumnUnits] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [colMappings, setColMappings] = useState([]);
    const [showResetModal, setShowResetModal] = useState(false);
    const [pendingFile, setPendingFile] = useState(null);
    //falda
    const [falda, setFalda] = useState(0);
    const [faldaAssente, setFaldaAssente] = useState(false);
    //dati prova
    const [nomeProva, setNomeProva] = useState("");
    const [committente, setCommittente] = useState("");
    const [localita, setLocalita] = useState("");
    const [indirizzo, setIndirizzo] = useState("");
    //modal editing profondità
    const [showProfModal, setShowProfModal] = useState(false);
    const [profStart, setProfStart] = useState("");
    const [profEnd, setProfEnd] = useState("");
    const [profStep, setProfStep] = useState("");
    //elabora stratigrafia
    const [showStratModal, setShowStratModal] = useState(false);
    const [tableDatastrat, setTableDatastrat] = useState([]);
    const [initialized, setInitialized] = useState(false);
    const [stratMediata, setStratMediata] = useState([]);
    //modal cancella riga
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState(null);
    //edit table
    const [isEditing, setIsEditing] = useState(false);
    //spyke
    const [spikeRows, setSpikeRows] = useState([]);
    //liquefazione
    const [showLiqueModal, setShowLiqueModal] = useState(false);
    const [mw, setMw] = useState("");
    const [accMax, setAccMax] = useState("");
    const [profMax, setProfMax] = useState(20);
    const [metodo, setMetodo] = useState("");
    const [csrVal, setCsrVal] = useState([]);
    const [csrH, setCsrH] = useState([]);
    const [liqueResult, setLiqueResult] = useState([]);
    const [metodolique, setmetodolique] = useState(-1);
    const [iplcalcolato, setiplcalcolato] = useState(-1);
    //cedimento Free Field
    const [verificaCedimento, setVerificaCedimento] = useState("no");
    const [cedtot, setcedtot] = useState(-1);
    //team condivisione prove
    const [teams, setTeams] = useState([]);
    const [selectedTeam, setSelectedTeam] = useState(null);
      // Carica dati iniziali
    useEffect(() => {
        fetchTeams();
    }, []);
    const fetchTeams = async () => {
      const token = localStorage.getItem("token");
      try {
        const res = await axios.get("https://www.hat.sofhare.com/elaborazioni/teams/", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTeams(res.data);
      } catch (err) {
        toast.error("Errore caricamento team!", { autoClose: 2000 });
      }
    };
    //archiviazione
    const [note, setnote] = useState("");

    const [formDatach, setFormDatach] = useState({
      tipo_prova: "",
      committente: "",
      luogo: "",
      indirizzo: "",
      nome_prova: "",
      commessa: "",
      stato: "",
      input_data: {},
      output_data: {},
      stratigraphy_data: {},
      ipl_rw: "",
      ipl_ib: "",
      note: "",
      param_data:{},
    });
    //parametri avanza\ti
    //CPTU/E
    const [ulitologia, setuLitologia] = useState("SBTn");
    const [ugamma, setugamma] = useState("SBTg");
    const [uphi, setuphi] = useState("km90");
    const [ufap, setfap] = useState("16");
    //CPT
    const [tmlitologia, settmLitologia] = useState("s78");
    const [tmgamma, settmgamma] = useState("ro10");
    const [tmphi, settmphi] = useState("beer");
    const [tmo, settmo] = useState("mg75"); //mod edometrico terreni incoerenti
    const [tmyo, settmyo] = useState("s78");
    const [tmdr, settmdr] = useState("la83");
    const [tmcu, settmcu] = useState("mk88");
    const [tmocr, settmocr] = useState("m91");
    const [tmdf, settmdf] = useState("v");
    const [tmoc, settmoc] = useState("mg75"); //mod edometrico terreni coesivi
    //popolamento output
    //configurazione dinamica della tabella
    const tableConfig = {
      CPTU: {
        columns: [
          { key: "prof", label: "Prof (m)" },
          { key: "qc", label: "qc (MPa)" },
          { key: "fs", label: "fs (kPa)" },
          { key: "u2", label: "u2 (kPa)" },
          { key: "u0", label: "u0 (kPa)" },
          { key: "Qt", label: "Qt (MPa)" },
          { key: "gammau", label: "γ (KN/m3)" },
          { key: "sv", label: "σv (kPa)" },
          { key: "svp", label: "σ'v (kPa)" },
          { key: "cu", label: "cu (kPa)" },
          { key: "phi", label: "φ (°)" },
          { key: "effPhi", label: <>φ'<sub>p</sub> (°)</> },
          { key: "Dr", label: "Dr (%)" },
          { key: "Rf", label: "Rf (%)" },
          { key: "FR", label: "FR (%)" },
          { key: "Qt1", label: "Qt1" },
          { key: "Qtn", label: "Qtn" },
          { key: "Bq", label: "Bq" },
          { key: "IC", label: "IC" },
          { key: "Es", label: "Es (MPa)" },
          { key: "M", label: "M (MPa)" },
          { key: "G0", label: "G0 (MPa)" },
          { key: "OCR", label: "OCR" },
          { key: "K0", label: "K0" },
          { key: "KSBT", label: "KSBT (cm/s)" },
        ]
      },

      CPTE: {
        columns: [
          { key: "prof", label: "Prof (m)" },
          { key: "qc", label: "qc (MPa)" },
          { key: "fs", label: "fs (kPa)" },
          { key: "Qt", label: "Qt (MPa)" },
          { key: "gammau", label: "γ (KN/m3)" },
          { key: "sv", label: "σv (kPa)" },
          { key: "svp", label: "σ'v (kPa)" },
          { key: "cu", label: "cu (kPa)" },
          { key: "phi", label: "φ (°)" },
          { key: "effPhi", label: <>φ'<sub>p</sub> (°)</> },
          { key: "Dr", label: "Dr (%)" },
          { key: "Rf", label: "Rf (%)" },
          { key: "FR", label: "FR (%)" },
          { key: "Qt1", label: "Qt1" },
          { key: "Qtn", label: "Qtn" },
          { key: "Bq", label: "Bq" },
          { key: "IC", label: "IC" },
          { key: "Es", label: "Es (MPa)" },
          { key: "M", label: "M (MPa)" },
          { key: "G0", label: "G0 (MPa)" },
          { key: "OCR", label: "OCR" },
          { key: "K0", label: "K0" },
          { key: "KSBT", label: "KSBT (cm/s)" },
        ]
      },

      CPT: {
        columns: [
          { key: "prof", label: "Prof (m)" },
          { key: "qc", label: "qc (MPa)" },
          { key: "fs", label: "fs (kPa)" },
          { key: "Rf", label: "Rf (%)" },
          { key: "gammasecc", label: "γ (KN/m3)" },
          { key: "gammasat", label: <>γ<sub>s</sub> (KN/m3)</> },
          { key: "sv", label: "σv (kPa)" },
          { key: "svp", label: "σ'v (kPa)" },
          { key: "Dr", label: "Dr (%)" },
          { key: "cu", label: "cu (kPa)" },
          { key: "effPhiP", label: "φ (°)" },
          { key: "Tipo", label: "Tipo" },
          { key: "OCR", label: "OCR" },
          { key: "K", label: "K (cm/s)" },
          { key: "Mo", label: "Mo (MPa)" },
          { key: "G", label: "G (MPa)" },
          { key: "Ey", label: "Ey (MPa)" },
          { key: "Eu", label: "Eu (MPa)" },
          { key: "Qcfs", label: "Qcfs" },
        ]
      },
    };


    //costruzione tabella output
    const buildRows = (data) => {
      if (!data || !data.H) return [];
      return data.H.map((_, i) => ({
        prof: data.H[i],
        qc: data.Qc?.[i],
        fs: data.fs?.[i],
        u2: data.u2?.[i],
        u0: data.u0?.[i],
        Qt: data.Qt?.[i],
        gammau: data.gamma?.[i],
        sv: data.sigma?.[i],
        svp: data.sigmaP?.[i],
        cu: data.cu?.[i],
        phi: data.phi?.[i],
        effPhi: data.effPhi?.[i],
        Dr: data.DR?.[i],
        Rf: data.Rf?.[i],
        FR: data.FR?.[i],
        Qt1: data.Qt1?.[i],
        Qtn: data.Qtn?.[i],
        Bq: data.bq?.[i],
        IC: data.IC?.[i],
        Es: data.Es?.[i],
        M: data.M?.[i],
        G0: data.G0?.[i],
        OCR: data.OCR?.[i],
        K0: data.K0?.[i],
        KSBT: data.Ksbt?.[i],
        //paramatrii cpt
        Eu: data.Eu?.[i],
        Ey: data.Ey?.[i],
        K: data.K?.[i],
        Tipo: data.TipoT?.[i],
        gammasat: data.gamma?.[i],
        gammasecc: data.GammaseccTab?.[i],
        effPhiP: data.effPhi?.[i],
        Mo: data.M?.[i],
        G: data.G0?.[i],
        //litologia per esit stratigrafico
        Lt: data.Lt[i],
        Qcfs: data.Lt[i],
      }));
    };

    const [tableOut, setTableOut] = useState(null);
    const columns = tableConfig[tipoProva].columns;
    const rows = buildRows(tableOut);

    //id geometria se da database
    const [idgeom, setidgeom] = useState(null);

    // Infotab resizing
    const infotabRef = useRef(null);
    const [infotabWidth, setInfotabWidth] = useState(500);
    const [isResizing, setIsResizing] = useState(false);
    const startX = useRef(0);
    const startWidth = useRef(0);

    // riempie atumaticamente i dati in fuzione di quello che arriva
     const [formData, setFormData] = useState({});
            useEffect(() => {
          if (incomingData) {
            setFormData(incomingData);
          }
        }, [incomingData]);
    //preparo i dati
     const buildTableFromIncoming = (data) => {
          if (!data.prof) return [];

          return data.prof.map((h, i) => ({
            N: i + 1,
            H: h,
            qc: data.parQC?.[i] ?? null,
            fs: data.parfs?.[i] ?? null,
            u2: data.paru?.[i] ?? null // CPTU
          }));
        };

    //se carico la prova dal database imposto le variabili
    // tabella
    useEffect(() => {
      if (incomingData && tableData.length === 0) {
        const newTable = buildTableFromIncoming(incomingData);
        setTableData(newTable);
      }
    }, [incomingData]);
    //autori paramentri CPTE
    //peso terreno
    useEffect(() => {
      if (incomingData?.waut !== undefined) {
        setugamma(incomingData.waut);
      }
    }, [incomingData]);
    //angolo attrito
    useEffect(() => {
      if (incomingData?.phiaut !== undefined) {
        setuphi(incomingData.phiaut);
      }
    }, [incomingData]);
    //fattore di punta 14-18
    useEffect(() => {
      if (incomingData?.fpt !== undefined) {
        setfap(incomingData.fpt);
      }
    }, [incomingData]);

    //autori paramentri CPT
    useEffect(() => {
      if (incomingData?.wautP !== undefined) {
        settmgamma(incomingData.wautP);
      }
    }, [incomingData]);
    //terreni incoerenti
    //angoloattrito
    useEffect(() => {
      if (incomingData?.phiautP!== undefined) {
        settmphi(incomingData.phiautP);
      }
    }, [incomingData]);
    //modulo edo
    useEffect(() => {
      if (incomingData?.moautP!== undefined) {
        settmo(incomingData.moautP);
      }
    }, [incomingData]);
    //modulo young
    useEffect(() => {
      if (incomingData?.yoautP!== undefined) {
        settmyo(incomingData.yoautP);
      }
    }, [incomingData]);
    //densita relativa
    useEffect(() => {
      if (incomingData?.drautP!== undefined) {
        settmdr(incomingData.drautP);
      }
    }, [incomingData]);
    //terrenicoesivi
    //cu
    useEffect(() => {
      if (incomingData?.cuautP!== undefined) {
        settmcu(incomingData.cuautP);
      }
    }, [incomingData]);
    //ocr
    useEffect(() => {
      if (incomingData?.ocrautP!== undefined) {
        settmocr(incomingData.ocrautP);
      }
    }, [incomingData]);
    //modulo di defnondrenato
    useEffect(() => {
      if (incomingData?.mdfautP!== undefined) {
        settmdf(incomingData.mdfautP);
      }
    }, [incomingData]);
    //modulo edo coesivi
    useEffect(() => {
      if (incomingData?.mdfautPc!== undefined) {
        settmoc(incomingData.mdfautPc);
      }
    }, [incomingData]);
    //tipo punta
    useEffect(() => {
      if (incomingData?.geompt !== undefined) {
        setGeometria(incomingData.geompt);
      }
    }, [incomingData]);
    // tipo prova
    useEffect(() => {
      if (incomingData?.tipo !== undefined) {
        setTipoProva(incomingData.tipo);
      }
    }, [incomingData]);
    // litologia
    useEffect(() => {
      if (incomingData?.ulitologiaStr !== undefined) {
        setuLitologia(incomingData.ulitologiaStr);
      }
    }, [incomingData]);
    //nomeprova
    useEffect(() => {
      if (incomingData) {
        if (incomingData.name !== undefined) {
          setNomeProva(incomingData.name);
        }
        }
    }, [incomingData]);
    //commitente
    useEffect(() => {
      if (incomingData) {
        if (incomingData.comm !== undefined) {
          setCommittente(incomingData.comm);
        }
        }
    }, [incomingData]);
    //località
    useEffect(() => {
      if (incomingData) {
        if (incomingData.loc !== undefined) {
          setLocalita(incomingData.loc);
        }
        }
    }, [incomingData]);
    //indirizzo
    useEffect(() => {
      if (incomingData) {
        if (incomingData.add !== undefined) {
          setIndirizzo(incomingData.add);
        }
        }
    }, [incomingData]);
    //id
    useEffect(() => {
      if (incomingData) {
        if (incomingData.id !== undefined) {
          setidgeom(incomingData.id);
        }
        }
    }, [incomingData]);
    //team_id
    //commitente
    useEffect(() => {
      if (incomingData) {
        if (incomingData.team_id !== undefined) {
          setSelectedTeam(incomingData.team_id);
        }
        }
    }, [incomingData]);
    //coordinate
    useEffect(() => {
      if (incomingData) {
        if (incomingData.coords2 !== undefined) {
          setCoordinate(incomingData.coords2);
        }
        }
    }, [incomingData]);
    // falda
    useEffect(() => {
          if (!incomingData?.prof) return;

          const maxH = Math.max(...incomingData.prof.map(h => Number(h) || 0));
          const faldaRaw = incomingData.fad;

          if (faldaRaw === undefined || faldaRaw === null || faldaRaw === "") {
            setFalda(0);
            setFaldaAssente(false);
            return;
          }

          const faldaValue = Number(faldaRaw);

          if (isNaN(faldaValue)) {
            setFalda(0);
            setFaldaAssente(false);
            return;
          }

          if (faldaValue > maxH) {
            setFaldaAssente(true);
            setFalda(maxH+1);
          } else {
            setFaldaAssente(false);
            setFalda(faldaValue); // 👈 numero vero
          }
        }, [incomingData]);


      const resetta = () => {
          navigate(location.pathname, { state: null });
          window.location.reload();
        };

    //funzione soft reset
    const resetAllForFileLoad = () => {
      // file / tabella
      setRawData([]);
      setTableData([]);
      setColMappings([]);
      setShowMapping(false);
      // progetto e mappa
      setSelectedProject('');
      setCoordinate('');
      setIsMapClickActive(false);
      // dati prova
      setNomeProva('');
      setCommittente('');
      setLocalita('');
      setIndirizzo('');
      //idgeometria
      setidgeom(null)
      // team
      setSelectedTeam(null);
      // stratigrafia
      setTableDatastrat([]);
      setStratMediata([]);
      // editing
      setIsEditing(false);
      // delete modal
      setShowDeleteModal(false);
      setDeleteIndex(null);
      // modali
      setShowProfModal(false);
      setShowStratModal(false);
      setShowLiqueModal(false);
      // falda (🔴 AGGIUNTO)
      setFalda(0);
      setFaldaAssente(false);
      // liquefazione
      setMw('');
      setAccMax('');
      setProfMax(20);
      setMetodo('');
      setCsrVal([]);
      setCsrH([]);
      setLiqueResult([]);
      setmetodolique(-1);
      setiplcalcolato(-1);
      setcedtot(-1);
      // file state
      setSpikeRows([]);
      // output
      setTableOut(null);
      // form data
      setFormDatach({
        tipo_prova: "",
        committente: "",
        luogo: "",
        indirizzo: "",
        nome_prova: "",
        commessa: "",
        stato: "",
        input_data: {},
        output_data: {},
        stratigraphy_data: {},
        ipl_rw: "",
        ipl_ib: "",
        note: "",
        param_data: {},
      });
    };

    //file txt prova
    const handleFile = (e) => {
      const file = e.target.files[0];
      if (!file) return;

      setPendingFile(file);
      setShowResetModal(true);
    };

    const loadFile = (file) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        const text = event.target.result;

        const righe = text
          .split("\n")
          .map(r => r.trim())
          .filter(r => r);

        const parsed = righe.map(r => r.split(/\s+/));

        setRawData(parsed);
        setColMappings(parsed[0].map(() => ({ field: "", unit: "" })));
        setShowMapping(true);
      };

      reader.readAsText(file);
    };

    const confirmFileLoad = () => {
      if (!pendingFile) return;
    
      resetAllForFileLoad(); // 🔥 SOLO qui
    
      setTableData([]);
      setRawData([]);
      setColMappings([]);
      setShowMapping(false);
    
      loadFile(pendingFile);
    
      setShowResetModal(false);
      setPendingFile(null);
    };
    
    const cancelFileLoad = () => {
      if (!pendingFile) return;
    
      loadFile(pendingFile);
    
      setShowResetModal(false);
      setPendingFile(null);
    };

    //carico i paraamentri di punta
    useEffect(() => {
      if (geometria && geometrieConfig[geometria]) {
        setParametri(geometrieConfig[geometria].parametri);
      }
    }, [geometria]);

    const convertValue = (value, field, unit, row = {}, parametri = {}) => {
      const v = parseFloat(value);
      if (isNaN(v)) return null;

      let result = v;
      let resultField = field;

      // profondità
      if (field === "profondita") {
        result = unit === "cm" ? v / 100 : v;
      }
      // resistenze
      if (["qc"].includes(field)) {
        if (unit === "kPa") result = v / 1000;
        if (unit === "kg/cmq") result = v * 0.098066; // → MPa
      }
      //fs e u2
      if (["fs", "u2"].includes(field)) {
        if (unit === "MPa") result = v * 1000;
        if (unit === "kg/cmq") result = v * 98.066; // → kPa

      }
      
      // CPT special case: l1 → qc, l2 → fs
      if (field === "l1") {
          if (!parametri.ct || !parametri.areaP) return null;
          result = (v * parametri.ct) / parametri.areaP * 0.0980665;
          resultField = "qc";
          row.l1 = v; // ← salva l1 nella riga per l2
      }
      if (field === "l2") {
          const l1Val = parseFloat(String(row.l1).replace(",", "."));
          if (!parametri.ct || !parametri.supManic || isNaN(l1Val)) return null;
          result = ((v - l1Val) * parametri.ct / parametri.supManic) * 98.0665;
          resultField = "fs";
      }

      return { value: result, field: resultField};
    };

   //conversione unita misura file
    const importData = () => {
      if (!parametri) return; // ❌ controlla che i parametri siano caricati

      // Controllo se ci sono colonne l1/l2 e tipo prova non corretto
      const hasL1orL2 = colMappings.some(col => ["l1", "l2"].includes(col?.field));
      if (hasL1orL2 && ["CPTU", "CPTE"].includes(tipoProva)) {
        if (typeof toast === "function") {
          toast("Seleziona Tipo di prova corretto prima di proseguire", { type: "warning" });
        } else {
          console.warn("Seleziona Tipo di prova corretto prima di proseguire");
        }
        return; // blocca tutta la funzione, non genera la tabella
      }

      const result = rawData
        .map((row, i) => {
          const newRow = { N: i + 1, H: null, qc: null, fs: null, u2: null };
          row.forEach((val, colIndex) => {
            const mapping = colMappings[colIndex];
            if (!mapping?.field) return;
            const cleanVal = String(val).trim().replace(",", ".");
            const num = parseFloat(cleanVal);
            if (isNaN(num)) return;
            // conversione con field finale
            const converted = convertValue(num, mapping.field, mapping.unit, row, parametri);
            if (!converted) return;
            if (converted.field === "profondita") newRow.H = converted.value;
            if (converted.field === "qc") newRow.qc = converted.value;
            if (converted.field === "fs") newRow.fs = converted.value;
            if (converted.field === "u2") newRow.u2 = converted.value;
          });
          return newRow;
        })
        .filter(row => row.H !== null)
        .sort((a, b) => a.H - b.H)
        .map((row, i) => ({ ...row, N: i + 1 }));
      setTableData(result);
      setShowMapping(false);
    };


    //gestione spyke
    const detectSpikes = () => {
      const spikes = [];

      for (let i = 1; i < tableData.length - 1; i++) { // da 1 a length-2 per avere prev e next
        const prev = tableData[i - 1];
        const curr = tableData[i];
        const next = tableData[i + 1];

        // Spike qc → deviazione maggiore di ±0.25 rispetto a prev e next
        if (
          (curr.qc - prev.qc > 0.25 || curr.qc - prev.qc < -0.25) &&
          (curr.qc - next.qc > 0.25 || curr.qc - next.qc < -0.25)
        ) {
          spikes.push(curr.N);
        }

        // Spike fs → deviazione maggiore di ±7 rispetto a prev e next
        if (
          (curr.fs - prev.fs > 7 || curr.fs - prev.fs < -7) &&
          (curr.fs - next.fs > 7 || curr.fs - next.fs < -7)
        ) {
          spikes.push(curr.N);
        }
      }
      setSpikeRows(spikes);
    };


    const smoothSpikes = () => {
      const newTable = [...tableData]; // copia per non modificare direttamente lo state

      for (let i = 1; i < newTable.length - 1; i++) {
        const prev = newTable[i - 1];
        const curr = newTable[i];
        const next = newTable[i + 1];

        // qc spike → deviazione maggiore di ±0.25 rispetto a prev e next
        if (
          (curr.qc - prev.qc > 0.25 || curr.qc - prev.qc < -0.25) &&
          (curr.qc - next.qc > 0.25 || curr.qc - next.qc < -0.25)
        ) {
          curr.qc = ((prev.qc ?? 0) + (next.qc ?? 0)) / 2;
        }

        // fs spike → deviazione maggiore di ±7 rispetto a prev e next
        if (
          (curr.fs - prev.fs > 7 || curr.fs - prev.fs < -7) &&
          (curr.fs - next.fs > 7 || curr.fs - next.fs < -7)
        ) {
          curr.fs = ((prev.fs ?? 0) + (next.fs ?? 0)) / 2;
        }
      }

      setTableData(newTable); // aggiorna la tabella
    };

    const openDeleteModal = (index) => {
          setDeleteIndex(index);
          setShowDeleteModal(true);
        };

        const confirmDelete = () => {
      if (deleteIndex !== null) {
        setTableData(prev => prev.filter((_, i) => i !== deleteIndex));
      }
      setShowDeleteModal(false);
      setDeleteIndex(null);
    };


    const openProfModal = () => {
      setProfStart("");
      setProfEnd("");
      setProfStep("");
      setShowProfModal(true);
    };

    const applyProfValues = () => {
      const s = parseFloat(profStart);
      const e = parseFloat(profEnd);
      const step = parseFloat(profStep);

      if (isNaN(s) || isNaN(e) || isNaN(step) || step <= 0 || e <= s) {
        toast.error("Inserisci valori validi!");
        return;
      }

      const nValues = Math.floor((e - s) / step) + 1;
      const newH = Array.from({ length: nValues }, (_, i) => +(s + i * step).toFixed(2));

      setTableData(prev =>
        prev.map((row, i) => ({
          ...row,
          H: newH[i] !== undefined ? newH[i] : row.H
        }))
      );

      setShowProfModal(false);
    };

    const handleElabora = () => {

          setLoadingelab(true);

          // 1️⃣ Aggrega i dati della tabella
          const aggregatedTableData = {
            H: tableData.map(row => row.H),
            qc: tableData.map(row => row.qc),
            fs: tableData.map(row => row.fs),
            u2: tableData.map(row => row.u2)
          };

          // 2️⃣ Costruisci JSON principale
          const jsonData = {
            committente,
            localita,
            indirizzo,
            nomeProva,
            tipoProva,
            geometria,
            falda: faldaAssente ? 150 : parseFloat(falda),
            faldaAssente,
            ...(tipoProva === "CPT"
              ? { tmlitologia, tmgamma, tmphi, tmo, tmyo, tmdr, tmcu, tmocr, tmdf, tmoc }
              : {}),
            ...((tipoProva === "CPTU" || tipoProva === "CPTE")
              ? { ulitologia, ugamma, uphi, ufap }
              : {}),
            tableData: aggregatedTableData
          };

          //console.log("JSON completo:", jsonData);
          console.log("JSON completo:", JSON.stringify(jsonData, null, 2));

          // 3️⃣ POST a Django
          axios.post("https://hat.sofhare.com/input/pstatic_elab/run-cpt/", jsonData, {
            headers: {
              "Authorization": `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json"
            }
          })
          .then(response => {
            // ✅ Adatta al nuovo formato response.data.response.task_id
            const taskId = response.data?.response?.task_id;

            if (!taskId) {
              console.error("Errore: task_id non ricevuto", response.data);
              setLoadingelab(false);
              return;
            }

            //console.log("Task ID ricevuto:", taskId);

            // 4️⃣ Avvia polling
            pollTask(taskId);


          })
          .catch(error => {
            console.error("Errore durante il POST:", error);
            setLoadingelab(false);

          });
        };


        // 5️⃣ Funzione di polling aggiornata (resta uguale)
    const pollTask = (taskId) => {
          const interval = setInterval(() => {
            axios.get(`https://hat.sofhare.com/input/pstatic_elab/status/${taskId}/`, {
              headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
            })
            .then(response => {
              const data = response.data?.response;
              if (!data) {
                console.error("Errore: risposta status vuota", response.data);
                clearInterval(interval);
                return;
              }
              if (data.status === "SUCCESS") {
                //("✅ Task completato! Risultato:", data.result);
                clearInterval(interval);
                setTableOut(data.result); // 🔥 aggiornato

                const defaultIncoming = {
                      unitup: [],
                      unitdw: [],
                      mlito: [],
                      mtype: '',
                      mname: '',
                      mgam: [],
                      mgams: [],
                      mcu: [],
                      mphi: [],
                      mdr: [],
                      mm: []
                    };

                const safeIncoming = incomingData ?? defaultIncoming;

                if (tipoProva === "CPTU" || tipoProva === "CPTE") {

                    const parautLT = ulitologia === "SBTn" ? 0 : 1;
                    viewCPTUReport(data.result,tipoProva,nomeProva,committente,localita,indirizzo,falda,parautLT,safeIncoming.unitup,safeIncoming.unitdw,safeIncoming.mlito,safeIncoming.mtype,
                            safeIncoming.mname,safeIncoming.mgam,safeIncoming.mcu,safeIncoming.mphi,safeIncoming.mdr,safeIncoming.mm); //disegna grafici

                    setLoadingelab(false);

                } else {

                    const parautLT = tmlitologia === "s78" ? 0 : 1;

                    const ltMap = {0:0,1:10,2:11,3:9,4:7,5:6,6:5,7:4,8:3,9:8,10:2,11:1};
                    const parLTdarimap= data.result.Lt

                    if (parautLT === 0) {
                        for (let i = 0; i < parLTdarimap.length; i++) {
                            parLTdarimap[i] = ltMap[parLTdarimap[i]] ?? 0;
                        }
                    }

                    viewCPTReport(data.result,tipoProva,nomeProva,committente,localita,indirizzo,falda,parautLT,parLTdarimap,safeIncoming.unitup,safeIncoming.unitdw,safeIncoming.mlito,safeIncoming.mlitoval,
                        safeIncoming.mtype,safeIncoming.mname,safeIncoming.mgam,safeIncoming.mgams,safeIncoming.mcu,safeIncoming.mphi,safeIncoming.mdr,safeIncoming.mm); //disegna grafici

                    setLoadingelab(false);

                }
              } else if (data.status === "FAILURE") {
                console.error("❌ Task fallito:", data.result);
                clearInterval(interval);
              } else {
                console.log("Task in corso:", data.status);
              }
            })
            .catch(error => {
              console.error("Errore polling task:", error);
              clearInterval(interval);
            });
         }, 2000); // ogni 2 secondi
    };

    //elaborazione stratigrafia
    useEffect(() => {
      if (showStratModal && !initialized) {
        const rows = Array.from({ length: 30 }, (_, i) => ({
          id: i + 1,
          nome: incomingData?.mname?.[i] || "",
          tetto: incomingData?.unitup?.[i] || "",
          letto: incomingData?.unitdw?.[i] || "",
          tipo: incomingData?.mtype?.[i] || "",
        }));
        setTableDatastrat(rows);
        setInitialized(true);
      }
    }, [showStratModal, incomingData, initialized]);

     const openStratModal = () => {
        setShowStratModal(true);
     };

     const propagateLettoToTetto = (rows, index, value) => {
        // se c'è una riga successiva
        if (index < rows.length - 1) {
            const updatedRow = { ...rows[index + 1], tetto: value };
            const updatedRows = [...rows];
            updatedRows[index + 1] = updatedRow;
            return updatedRows;
        }
        return rows;
    };

     const updateCell = (index, field, value) => {
        setTableDatastrat(prev => {
            // clona l'array originale
            let updated = [...prev];

            // aggiorna il campo selezionato della riga corrente
            updated[index] = { ...updated[index], [field]: value };

            // se sto aggiornando 'letto', propagalo al 'tetto' della riga successiva
            if (field === "letto") {
                updated = propagateLettoToTetto(updated, index, value);
            }

            return updated;
        });
    };

     //conferma modello stratigrafia e ricalcola per avere output stratigrafico
     const getstrat = () => {
          if (!tableOut || !tableOut.M) {
            toast.warning("Elabora i dati prima di ottenere la stratigrafia");
            return;
          }

          const datiPuliti = tableDatastrat.filter(row =>
            row.nome.trim() !== "" && row.tetto.toString().trim() !== "" &&
                row.letto.toString().trim() !== "" && row.tipo.trim() !== ""
            );

          if (datiPuliti.length === 0) {
            toast.warning("Nessuna stratigrafia da elaborare");
            return;
          }

          const mediaNonZero = (arr) => {
            const filtered = arr.filter(v => v !== 0 && v != null);
            if (filtered.length === 0) return 0;
            return filtered.reduce((a,b) => a+b, 0) / filtered.length;
          };

         const moda = (arr) => {
              const freq = {};

              // costruisci frequenze ignorando 0, null e undefined
              arr.forEach(v => {
                if (v !== 0 && v !== null && v !== undefined) {
                  freq[v] = (freq[v] || 0) + 1;
                }
              });

              let maxCount = 0;
              let modaVal = 0; // se non trova nulla restituisce 0

              // prendi il valore con frequenza massima
              Object.entries(freq).forEach(([val, count]) => {
                if (count > maxCount) {
                  maxCount = count;
                  modaVal = Number(val);
                }
              });

              return modaVal;
            };
                

          const stratMediata = datiPuliti.map(row => {
            const start = Number(row.tetto);
            const end = Number(row.letto);

            const indices = tableOut.H
              .map((h, i) => ({h, i}))
              .filter(({h}) => h >= start && h <= end)
              .map(obj => obj.i);

            // 🔧 dichiarazione variabili
            let gammaSArr, gammauArr, phiArr, DrArr, CuArr, MArr, LtArr;

            if (tipoProva === "CPTU" || tipoProva === "CPTE") {
              gammauArr = indices.map(i => tableOut.gamma?.[i] ?? 0);
              phiArr    = indices.map(i => tableOut.phi?.[i] ?? 0);
              DrArr     = indices.map(i => tableOut.DR?.[i] ?? 0);
              CuArr     = indices.map(i => tableOut.cu?.[i] ?? 0);
              MArr      = indices.map(i => tableOut.M?.[i] ?? 0);
              LtArr     = indices.map(i => tableOut.Lt?.[i] ?? null);

            } else if (tipoProva === "CPT") {
              gammaSArr = indices.map(i => tableOut.gamma?.[i] ?? 0);
              gammauArr = indices.map(i => tableOut.GammaseccTab?.[i] ?? 0);
              phiArr    = indices.map(i => tableOut.effPhi?.[i] ?? 0);
              DrArr     = indices.map(i => tableOut.DR?.[i] ?? 0);
              CuArr     = indices.map(i => tableOut.cu?.[i] ?? 0);
              MArr      = indices.map(i => tableOut.Mo?.[i] ?? 0);
              LtArr     = indices.map(i => tableOut.Lt?.[i] ?? null);
            }

            const result = {
              mnome: row.nome,
              mtipo: row.tipo,
              mtetto: start,
              mletto: end,
              mgammaS: gammaSArr ? mediaNonZero(gammaSArr) : null,
              mgammau: mediaNonZero(gammauArr),
              mphi: mediaNonZero(phiArr),
              mDr: mediaNonZero(DrArr),
              mcu: mediaNonZero(CuArr),
              mM: mediaNonZero(MArr),
              mLt: moda(LtArr)
            };

            // 🔧 regole sui tipi
            if (row.tipo === "TSA") {
              result.mM = 0;
              result.mcu = 0;
              result.mDr = 0;
              result.mphi = 0;
            }

            if (row.tipo === "I") {
              result.mcu = 0;
            }

            if (row.tipo === "C") {
              result.mphi = 0;
              result.mDr = 0;
            }

            return result;
          });
            // ✅ CREA ARRAY PER IL PLOT
          const mtetto  = stratMediata.map(s => s.mtetto);
          const mletto  = stratMediata.map(s => s.mletto);
          const mLt     = stratMediata.map(s => s.mLt);
          const mtipo   = stratMediata.map(s => s.mtipo);
          const mnome   = stratMediata.map(s => s.mnome);
          const mgammau = stratMediata.map(s => s.mgammau);
          const mgammaSArr = stratMediata.map(s => s.mgammaS);
          const mcuArr  = stratMediata.map(s => s.mcu);
          const mphiArr = stratMediata.map(s => s.mphi);
          const mDrArr  = stratMediata.map(s => s.mDr);
          const mMArr   = stratMediata.map(s => s.mM);

          //forzo la profondità finale ad esere = alla prof max
          if (mletto.length > 0) {mletto[mletto.length - 1] = Math.max(...tableOut.H);}


          if (tipoProva === "CPTU" || tipoProva === "CPTE") {

            const parautLT = ulitologia === "SBTn" ? 0 : 1;
            viewCPTUReport(tableOut,tipoProva,nomeProva,committente,localita,indirizzo,falda,parautLT,mtetto,mletto,mLt,mtipo,
                    mnome,mgammau,mcuArr,mphiArr,mDrArr,mMArr); //disegna grafici


         } else {
            const parautLT = tmlitologia === "s78" ? 0 : 1;

            const ltMap = {0:0,1:10,2:11,3:9,4:7,5:6,6:5,7:4,8:3,9:8,10:2,11:1};
            const invLtMap = {};
            Object.entries(ltMap).forEach(([key, value]) => {
                invLtMap[value] = Number(key);
            });

            const valueLt = tableOut.Lt.map(v => invLtMap[v] ?? 0);
            const mlitoval = mLt.map(v => invLtMap[v] ?? 0);

            viewCPTReport(tableOut,tipoProva,nomeProva,committente,localita,indirizzo,falda,parautLT,valueLt,
                mtetto,mletto,mLt, mlitoval,mtipo,mnome,mgammau,mgammaSArr,mcuArr,mphiArr,mDrArr,mMArr); //disegna grafici

        }
         setStratMediata(stratMediata);
         //console.log("Stratigrafia mediata:", stratMediata);
         setShowStratModal(false)
        };

     //verifica liquefazion
     const openLiqueModal = () => {
        setCsrVal([]);
        setCsrH([]);
        setShowLiqueModal(true);
     };


     const handleCSRFile = (e) => {
          const file = e.target.files[0];
          if (!file) return;

          const reader = new FileReader();

          reader.onload = (event) => {
            const text = event.target.result;

            const lines = text
              .split("\n")
              .map(l => l.trim())
              .filter(l => l.length > 0);

            const val = [];
            const h = [];

            lines.forEach(line => {
              // 🔥 split su uno o più spazi
              const [v, depth] = line.split(/\s+/).map(x => x.trim());

              const vNum = Number(v);
              const hNum = Number(depth);

              if (!isNaN(vNum) && !isNaN(hNum)) {
                val.push(vNum);
                h.push(hNum);
              }
            });

            setCsrVal(val);
            setCsrH(h);
          };

          reader.readAsText(file);
        };


     const handleConfirm = () => {

          let inputliq = {};

          function computeStep(H) {
              const steps = [];

              // prendo solo i primi valori "buoni"
              const limit = Math.min(H.length - 1, 20);

              for (let i = 1; i <= limit; i++) {
                const dh = Math.abs(H[i] - H[i - 1]);
                if (!isNaN(dh) && dh > 0) {
                  steps.push(dh);
                }
              }

              // media semplice
              const avg = steps.reduce((a, b) => a + b, 0) / steps.length;

              return avg;
            }

          function snapStep(step) {
              const grid = [0.01, 0.02, 0.025, 0.05, 0.1, 0.2, 0.25, 0.5, 1];

              let closest = grid[0];
              let minDiff = Math.abs(step - closest);

              for (const g of grid) {
                const diff = Math.abs(step - g);
                if (diff < minDiff) {
                  minDiff = diff;
                  closest = g;
                }
              }

              return closest;
            }


          if (tipoProva === "CPTU" || tipoProva === "CPTE") {

            const H = tableOut?.H || [];
            const QC = tableOut?.Qc || [];
            const FS = tableOut?.fs || [];
            const gamma = tableOut?.gamma || [];
            const IC = tableOut?.IC || [];

            const UU = (tipoProva === "CPTE")
              ? QC.map(() => 0)
              : (tableOut?.u2 || []);

            const Hfalda = falda;

            // 🔴 CONTROLLO FALDA
            const hMax = Math.max(...H);
            if (Hfalda == null || Hfalda > hMax) {
              toast.error("Falda non presente, impossibile procedere");
              return {};
            }

            // GammaSat
            const GammaSat = H.map((h, i) => {
              return (h >= Hfalda) ? gamma[i] + 1 : gamma[i];
            });

            // QC e FS filtrati con IC
            const QC_clean = QC.map((q, i) =>
              IC[i] === 0 ? 0 : q
            );

            const FS_clean = FS.map((f, i) =>
              IC[i] === 0 ? 0 : f
            );
            // ΔH (passo)
            const deltaH = snapStep(computeStep(H));
            //metodo
            const metodoNum = metodo === "1" ? 0 : metodo === "2" ? 1 : null;
            //calcolo cedimenti
            const cedimentoFlag = verificaCedimento === "si" ? 1 : 0;

            inputliq = {
              H,
              QC: QC_clean,
              FS: FS_clean,
              Gam: gamma,
              GamSat: GammaSat,
              UU,
              ValFdUlk: Hfalda,
              lettIulk: deltaH,
              MMxUlk: Number(mw),
              ACCUlk: Number(accMax),
              prefUlk: H[0],
              metdUlk: metodoNum,
              CSRval: (csrVal && csrVal.length > 0) ? csrVal : 0,
              CSRh: (csrH && csrH.length > 0) ? csrH : 0,
              HIPL: Number(profMax),
              ced: cedimentoFlag
            };
          }

          else if (tipoProva === "CPT") {

            const H = tableOut?.H || [];
            const QC = tableOut?.Qc || [];
            const FS = tableOut?.fs || [];
            const gamma = tableOut?.gammasecc || [];
            const GammaSat = tableOut?.gammasat || [];

            const Hfalda = falda;

            // 🔴 CONTROLLO FALDA
            const hMax = Math.max(...H);
            if (Hfalda == null || Hfalda > hMax) {
              toast.error("Falda non presente, impossibile procedere");
              return {};
            }

            // UU = sempre zero
            const UU = QC.map(() => 0);
            // ΔH
            const deltaH = snapStep(computeStep(H));
            //metodo
            const metodoNum = metodo === "1" ? 0 : metodo === "2" ? 1 : null;
            //calcolo cedimenti
            const cedimentoFlag = verificaCedimento === "si" ? 1 : 0;

            inputliq =  {
              H,
              QC,
              FS,
              Gam: gamma,
              GamSat: GammaSat,
              UU,
              FALDA: Hfalda,
              lettIulk: deltaH,
              MMxUlk: Number(mw),
              ACCUlk: Number(accMax),
              prefUlk: H[0],
              metdUlk: metodoNum,
              CSRval: (csrVal && csrVal.length > 0) ? csrVal : 0,
              CSRh: (csrH && csrH.length > 0) ? csrH : 0,
              HIPL: Number(profMax),
              ced: cedimentoFlag
            };
          }
          //console.log("🚀 LIQUEFACTION INPUT:", inputliq);
          //console.log("🚀 LIQUEFACTION INPUT (JSON):", JSON.stringify(inputliq, null, 2));
          //return inputliq;
            // 🔥 QUI AGGIUNGI IL POST
          setLoadingelab(true);

          axios.post("https://hat.sofhare.com/input/pstatic_elab/run-lique/", inputliq, {
            headers: {
              "Authorization": `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json"
            }
          })
          .then(response => {
            const taskId = response.data?.response?.task_id;

            if (!taskId) {
              console.error("Errore: task_id non ricevuto", response.data);
              setLoadingelab(false);
              return;
            }

            //console.log("Task Lique ricevuto:", taskId);

            // 👉 puoi riusare pollTask oppure crearne uno dedicato
            pollTaskLique(taskId);

          })
          .catch(error => {
            console.error("Errore durante il POST Lique:", error);
            setLoadingelab(false);
          });
        };

     const pollTaskLique = (taskId) => {
      const interval = setInterval(() => {
        axios.get(`https://hat.sofhare.com/input/pstatic_elab/status/${taskId}/`, {
          headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
        })
        .then(response => {
          const data = response.data?.response;

          if (!data) {
            console.error("Errore: risposta status vuota", response.data);
            clearInterval(interval);
            return;
          }

          if (data.status === "SUCCESS") {
            clearInterval(interval);

            //console.log("✅ Lique completato:", data.result);

            // 👉 qui gestisci output liquefazione
            //setLiqueResult(tipoProva,nomeProva,committente,localita,indirizzo,falda,data.result);
            viewLIQUEReport(data,tipoProva,nomeProva,committente,localita,indirizzo,falda);

            setmetodolique(data?.result?.metodo ?? -1);

            setiplcalcolato(
              Number.isFinite(data?.result?.IndiceLiquefazione)
                ? data.result.IndiceLiquefazione
                : -1
            );

            setcedtot(data?.result?.cedimento ?? -1);


            setLoadingelab(false);
            setShowLiqueModal(false);
            setActivePanel("iplreport");
          } else if (data.status === "FAILURE") {
            console.error("❌ Lique fallito:", data.result);
            clearInterval(interval);
            setLoadingelab(false);
          }
        })
        .catch(error => {
          console.error("Errore polling Lique:", error);
          clearInterval(interval);
          setLoadingelab(false);
        });

      }, 2000);
    };


     //archiviazione dati su database
     //costruzione json inpput, output, lito
     // costruisce input_data in base a tipoProva
     const buildInputData = (tipoProva, tableOut) => {
      if (tipoProva === "CPTU" || tipoProva === "CPTE") {
        return {
          FS: tableOut?.fs || [],
          H: tableOut?.H || [],
          LL: 0,
          LP: 0,
          LT: 0,
          QC: tableOut?.Qc || [],
          Tipo: tipoProva,
          UU: tableOut?.u2 || []
        };
      } else if (tipoProva === "CPT") {
        return {
          FS: tableOut?.fs || [],
          H: tableOut?.H || [],
          LL: 0,
          LP: 0,
          LT: 0,
          QC: tableOut?.Qc || [],
          Tipo: tipoProva,
          UU: 0
        };
      }
      return {}; // default fallback
     };

    // costruisce output_data in base a tipoProva
    const buildOutputData = (tipoProva, tableOut) => {
      if (tipoProva === "CPTU" || tipoProva === "CPTE") {
        return [
          {
            Bq: tableOut?.bq || [],
            DR: tableOut?.DR || [],
            Es: tableOut?.Es || [],
            FS: tableOut?.fs || [],
            Fr: tableOut?.FR || [],
            G0: tableOut?.G0 || [],
            Gam: tableOut?.gamma || [],
            H: tableOut?.H || [],
            IC: tableOut?.IC || [],
            IC_SBT: tableOut?.Ksbt || [],
            K: tableOut?.KSBT || [],
            Lito: tableOut?.Lt || [],
            M: tableOut?.M || [],
            OCR: tableOut?.OCR || [],
            QC: tableOut?.Qc || [],
            Qt: tableOut?.Qt || [],
            Qt1: tableOut?.Qt1 || [],
            Qtn: tableOut?.Qtn || [],
            Rf: tableOut?.Rf || [],
            Sig: tableOut?.sigma || [],
            SigP: tableOut?.sigmaP || [],
            Tipo: tipoProva,
            U0: tableOut?.u0 || [],
            UU: tableOut?.u2 || [],
            choseLito : ulitologia === "SBTn" ? 0 : 1,
            cu: tableOut?.cu || [],
            cuRem: tableOut?.cu || [],
            falda: falda,                // verifica quando è assente come si comporta
            k0: tableOut?.K0 || [],
            phi: tableOut?.phi || [],
            phip: tableOut?.effPhi || []
          }
        ];
      }else if (tipoProva === "CPT") {

        const parautLT = tmlitologia === "s78" ? 0 : 1;
        const ltMap = {0:0,1:10,2:11,3:9,4:7,5:6,6:5,7:4,8:3,9:8,10:2,11:1};
        const invLtMap = {};
        Object.entries(ltMap).forEach(([key, value]) => {
          invLtMap[value] = Number(key);
        });
        const LitoFinal = parautLT === 0
          ? (tableOut?.Lt || []).map(v => invLtMap[v] ?? 0)
          : (tableOut?.Lt || []);


        return [
          {
            DR: tableOut?.DR || [],
            Eu: tableOut?.Eu || [],
            Ey: tableOut?.Ey || [],
            FS: tableOut?.fs || [],
            G0: tableOut?.G0 || [],
            Gam: tableOut?.gammasecc || [],
            GamS: tableOut?.gammasat || [],
            H: tableOut?.H || [],
            K: tableOut?.K || [],
            Lito: LitoFinal || [],
            M: tableOut?.M || [],
            OCR: tableOut?.OCR || [],
            QC: tableOut?.Qc || [],
            Qcfs: tableOut?.Qcfs || [],
            Rf: tableOut?.Rf || [],
            Sig: tableOut?.sigma || [],
            SigP: tableOut?.sigmaP || [],
            Tipo: tipoProva,
            TipoT: tableOut?.TipoT || [],
            choseLito : tmlitologia === "s78" ? 0 : 1,
            cu: tableOut?.cu || [],
            falda: falda,                // verifica quando è assente come si comporta
            phip: tableOut?.effPhi || []
          }
        ];
      }
      return [];
    };

    const buildLTdata = (tipoProva) => {
          const defaultIncoming = {
            unitup: [],
            unitdw: [],
            mlito: [],
            mtype: [],
            mname: [],
            mgam: [],
            mgams: [],
            mcu: [],
            mphi: [],
            mdr: [],
            mm: []
          };

          const safeIncoming = incomingData ?? defaultIncoming;
          const isStratEmpty = () => {
            if (!stratMediata || stratMediata.length === 0) return true;

            return stratMediata.every(s =>
              (s.mcu ?? 0) === 0 &&
              (s.mDr ?? 0) === 0 &&
              (s.mgammau ?? 0) === 0 &&
              (s.mphi ?? 0) === 0 &&
              (s.mM ?? 0) === 0
            );
          };

          if (!isStratEmpty()) {

            const parautLT = tmlitologia === "s78" ? 0 : 1;

              //const ltMap = {0:0,1:10,2:11,3:9,4:7,5:6,6:5,7:4,8:3,9:8,10:2,11:1};
              //const invLtMap = {};
              //Object.entries(ltMap).forEach(([key, value]) => {
              //  invLtMap[value] = Number(key);
              // });

              //const MlitoFinal = parautLT === 0
              //  ? stratMediata.map(s => invLtMap[s.mLt] ?? 0)
              //  : stratMediata.map(s => s.mLt ?? 0);

            return [{
              Letto: stratMediata.map(s => (s.mletto ?? 0).toString()),
              Tetto: stratMediata.map(s => (s.mtetto ?? 0).toString()),
              nomeS: stratMediata.map(s => s.mnome ?? ""),
              Tipoterr: stratMediata.map(s => s.mtipo ?? ""),

              MCu: stratMediata.map(s => s.mcu ?? 0),
              MDr: stratMediata.map(s => s.mDr ?? 0),
              MGamma: stratMediata.map(s => s.mgammau ?? 0),

              // fallback intelligente
              MGammaS: stratMediata.map(s => s.mgammaS ?? s.mgammau ?? 0),

              MM: stratMediata.map(s => s.mM ?? 0),
              MPhi: stratMediata.map(s => s.mphi ?? 0),

              Mlito: stratMediata.map(s => s.mLt ?? 0), //MlitoFinal,

              Tipo: tipoProva
            }];
          }

          if (incomingData && isStratEmpty()) {
            return [{
              Letto: (safeIncoming.unitdw || []).map(v => v.toString()),
              Tetto: (safeIncoming.unitup || []).map(v => v.toString()),
              nomeS: safeIncoming.mname || [],
              Tipoterr: safeIncoming.mtype || [],

              MCu: safeIncoming.mcu || [],
              MDr: safeIncoming.mdr || [],
              MGamma: safeIncoming.mgam || [],
              MGammaS: safeIncoming.mgams || [],

              MM: safeIncoming.mm || [],
              MPhi: safeIncoming.mphi || [],
              Mlito: safeIncoming.mlito || [],

              Tipo: tipoProva
            }];
          }

          return [{
            Letto: [],
            Tetto: [],
            nomeS: [],
            Tipoterr: [],
            MCu: [],
            MDr: [],
            MGamma: [],
            MGammaS: [],
            MM: [],
            MPhi: [],
            Mlito: [],
            Tipo: tipoProva
          }];
        };

    const buildParamData = (tipoProva) => {
      // Valori di default presi dagli useState
      if (tipoProva === "CPTU" || tipoProva === "CPTE") {
        // 🔹 Per CPTU/CPTE puoi fare eventuali modifiche
         const defaultParams = {
            waut: ugamma ?? "SBTg",
            phiaut: uphi ?? "km90",
            fpt: Number(ufap ?? 16),
            geompt: geometria ?? "Tp"
          };
        return defaultParams;
      } else if (tipoProva === "CPT") {
        // 🔹 Per CPT eventuali modifiche
          const defaultParams = {
            wautP: tmgamma ?? "ro10",
            phiautP: tmphi ?? "beer",
            moautP: tmo ?? "mg75",
            yoautP: tmyo ?? "s78",
            drautP: tmdr ?? "la83",
            cuautP: tmcu ?? "mk88",
            ocrautP: tmocr ?? "m91",
            mdfautP: tmdf ?? "v",
            mdfautPc: tmoc ?? "mg75"
          };
        return defaultParams;
      }
    };


    const toDB = async () => {
      try {
        const input_data = buildInputData(tipoProva, tableOut);
        const output_data = buildOutputData(tipoProva, tableOut);
        const stratigraphy_data = buildLTdata();
        const param_data = buildParamData(tipoProva);

        let geomString;

        if (typeof coordinate === 'string' && coordinate.trim() !== '') {

          const parts = coordinate.trim().split(',');

          if (
            parts.length !== 2 ||
            isNaN(Number(parts[0])) ||
            isNaN(Number(parts[1]))
          ) {

            if (typeof toast === "function") {
              toast(
                "Coordinate non valide. Usare il formato longitudine,latitudine",
                { type: "error" }
              );
            }

            return;
          }

          geomString = `${Number(parts[0])},${Number(parts[1])}`;


        } else if (Array.isArray(coordinate) && coordinate.length === 2) {


          if (
            isNaN(Number(coordinate[0])) ||
            isNaN(Number(coordinate[1]))
          ) {

            if (typeof toast === "function") {
              toast(
                "Coordinate non valide.",
                { type: "error" }
              );
            }

            return;
          }


          geomString = `${Number(coordinate[0])},${Number(coordinate[1])}`;


        } else {


          if (typeof toast === "function") {
            toast(
              "Impossibile archiviare la prova: inserire le coordinate.",
              { type: "error" }
            );
          }

          return;

        }

        let ipl_rw = -1;
        let ipl_ib = -1;

        let ced = cedtot


        if (metodolique === 0) {
          ipl_ib = iplcalcolato;
        }
        else if (metodolique === 1) {
          ipl_rw = iplcalcolato;
        }

        const formData = {
          tipo_prova: tipoProva,
          committente: committente,
          luogo: localita,
          indirizzo: indirizzo,
          nome_prova: nomeProva,
          note: note,
          ipl_rw: ipl_rw,
          ipl_ib: ipl_ib,
          ced:ced,
          geom:geomString,
          input_data: input_data,
          output_data: output_data,
          stratigraphy_data: stratigraphy_data,
          param_data: param_data,
          team_id:selectedTeam,
        };

        let response;

        const config = {
          headers: {
            "Authorization": `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json"
          }
        };

        if (idgeom) {
          // UPDATE
          response = await axios.put(
            `https://hat.sofhare.com/save-geognostiche/${idgeom}/`,
            formData,
            config
          );
          //console.log("UPDATE");
          if (typeof toast === "function") {
            toast("Aggiornamento completato con successo!", { type: "success" });
            }
        } else {
          // CREATE
          response = await axios.post(
            `https://hat.sofhare.com/save-geognostiche/`,
            formData,
            config
          );
          //console.log("CREATE");
          setidgeom(response.data.id);
          if (typeof toast === "function") {
            toast("Archiviazione completata con successo!", { type: "success" });
          }}
      } catch (error) {
        console.error("Errore completo:", error.response?.data || error);
      }
    };

    //resizing infotab
    const handleMouseDown = (event) => {
        setIsResizing(true);
        startX.current = event.clientX;
        startWidth.current = infotabRef.current.offsetWidth;

        const handleMouseMove = (e) => {
            const newWidth = Math.max(150, startWidth.current + (e.clientX - startX.current));
            setInfotabWidth(newWidth);
        };

        const handleMouseUp = () => {
            setIsResizing(false);
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    // Render menu content
    const renderContent = () => {
        switch (selectedMenu) {
            case 'input':
                return (
                    <div className="container-software">
                        <div className="container-select">
                            <div className="field">
                              <label className="label">Tipo di prova</label>
                              <select className="layout-select" value={tipoProva} onChange={(e) => setTipoProva(e.target.value)}>
                                <option value="CPTU">CPTU</option>
                                <option value="CPTE">CPTE</option>
                                <option value="CPT">CPT</option>
                              </select>
                              </div>
                             <div className="field">
                              <label className="label">Geometria punta</label>
                                    {(tipoProva === "CPTU" || tipoProva === "CPTE")  && (
                                        <select className="layout-select" value={geometria} onChange={(e) => setGeometria(e.target.value)}>
                                    <option value="Tp">Tecno penta</option>
                                    <option value="P200kN">Pagani 200kN</option>
                                  </select>
                                )}
                                {tipoProva === "CPT" &&
                                    <select className="layout-select" value={geometria} onChange={(e) => setGeometria(e.target.value)}>
                                    <option value="P100kN">Pagani 100kN</option>
                                    <option value="P200kN63">Pagani 200kN Tg63</option>
                                    <option value="DD">Deep drill</option>
                                  </select>}
                                  <div className="data-section">
                             </div>
                        </div>
                        {/* NUOVI CAMPI */}
                        <div className="container-select">
                            <div className="field">
                              <label className="label">Falda m da p.c.</label>
                              <input
                                  type="number"
                                  className="input-falda"
                                  value={falda}
                                  onChange={(e) => setFalda(e.target.value)}
                                  disabled={faldaAssente}
                                  placeholder="0"
                                  min="0"
                                  step="0.01"
                                />
                            </div>

                            <div className="field">
                             <label className="label">Check Falda</label>
                              <div
                                className={`switch ${faldaAssente ? "active" : ""}`}
                                className={`switch ${faldaAssente ? "active" : ""}`}
                                onClick={() => {
                                  const newValue = !faldaAssente;
                                  setFaldaAssente(newValue);
                                  if (newValue) setFalda(0);
                                }}
                              >
                                {faldaAssente ? "Falda ASSENTE" : "Falda presente"}
                              </div>
                            </div>
                        </div>
                        {/* MAPPING PANEL */}
                        {showMapping && (
                        <div className="mapping-table-wrapper">
                          <div className="mapping-panel">
                            <h4>Importa dati</h4>

                            <table className="mapping-table">
                              <thead>
                                <tr>
                                  {rawData[0]?.map((_, colIndex) => (
                                    <th key={colIndex}>
                                      <select
                                        value={colMappings[colIndex]?.field || ""}
                                        onChange={(e) =>
                                          setColMappings((prev) => {
                                            const copy = [...prev];
                                            copy[colIndex] = { ...copy[colIndex], field: e.target.value };
                                            return copy;
                                          })
                                        }
                                      >
                                        <option value="">--Value--</option>
                                        <option value="profondita">H</option>
                                        <option value="qc">qc</option>
                                        <option value="fs">fs</option>
                                        <option value="u2">u2</option>
                                        <option value="l1">l1</option>
                                        <option value="l2">l2</option>
                                      </select>
                                      <select
                                        value={colMappings[colIndex]?.unit || ""}
                                        onChange={(e) =>
                                          setColMappings((prev) => {
                                            const copy = [...prev];
                                            copy[colIndex] = { ...copy[colIndex], unit: e.target.value };
                                            return copy;
                                          })
                                        }
                                      >
                                        <option value="">--u.m.--</option>
                                          {(colMappings[colIndex]?.field === "profondita"
                                            ? ["m", "cm"]
                                            : colMappings[colIndex]?.field === "l1" || colMappings[colIndex]?.field === "l2"
                                            ? ["kg/cmq"]
                                            : ["MPa", "kPa", "kg/cmq"]
                                          ).map((unit) => (
                                            <option key={unit} value={unit}>{unit}</option>
                                          ))}
                                      </select>
                                    </th>
                                  ))}
                                </tr>
                              </thead>

                              <tbody>
                                {rawData.slice(0, 5).map((riga, i) => (
                                  <tr key={i}>
                                    {riga.map((val, j) => (
                                      <td key={j}>{val}</td>
                                    ))}
                                  </tr>
                                ))}
                              </tbody>
                            </table>

                            <button className="btn" onClick={importData}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                              <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                            </svg>
                            </button>
                          </div>
                         </div>
                        )}

                        {showResetModal && (
                          <div className="modal-overlay">
                            <div className="modal-content">

                              <h3 style={{ marginBottom: "10px" }}>Caricamento file</h3>

                              <p style={{ marginBottom: "20px" }}>
                                Vuoi resettare anagrafica e parametri prima di caricare il file?
                              </p>

                              <div className="modal-buttons">
                                <button
                                  onClick={confirmFileLoad}
                                  className="btnsw"
                                  style={{
                                    backgroundColor: "#e53935",
                                    color: "white",
                                    marginRight: "10px"
                                  }}
                                >
                                  Sì, resetta
                                </button>

                                <button
                                  onClick={cancelFileLoad}
                                  className="btnsw"
                                  style={{
                                    backgroundColor: "#555",
                                    color: "white"
                                  }}
                                >
                                  No, mantieni
                                </button>
                              </div>

                            </div>
                          </div>
                        )}

                        {/* BOTTONI */}
                        <div className="toolbarsw">
                          <input type="file" accept=".txt" ref={fileInputRef} style={{ display: "none" }} onChange={handleFile} />
                          <button className="btnsw" onClick={() => fileInputRef.current.click()}>
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15m0-3-3-3m0 0-3 3m3-3V15" />
                                </svg>
                              <span className="tooltip-text">
                                  File txt: <br />valori separati da spazio, <br />senza header.<br /> Es:<br />
                                  12 45 78<br />
                                  34 56 90
                              </span>
                          </button>

                          <button type="button" className="btnsw" onClick={openProfModal}>
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M2.243 4.493v7.5m0 0v7.502m0-7.501h10.5m0-7.5v7.5m0 0v7.501m4.501-8.627 2.25-1.5v10.126m0 0h-2.25m2.25 0h2.25" />
                              </svg>
                              <span className="tooltip-text">Edita profondità</span>
                          </button>
                          {showProfModal && (
                              <div className="modal-overlay">
                                <div className="modal-content">
                                  <h3>Edita profondità</h3>
                                  <label>
                                    Prof. inizio prova:
                                    <input type="number" step="0.01" value={profStart} onChange={e => setProfStart(e.target.value)} />
                                  </label>
                                  <label>
                                    Prof. fine prova:
                                    <input type="number" step="0.01" value={profEnd} onChange={e => setProfEnd(e.target.value)} />
                                  </label>
                                  <label>
                                    Passo letture:
                                    <input type="number" step="0.01" value={profStep} onChange={e => setProfStep(e.target.value)} />
                                  </label>
                                  <div className="modal-buttons">
                                    <button onClick={applyProfValues} className="btnsw">OK</button>
                                    <button onClick={() => setShowProfModal(false)} className="btnsw">Annulla</button>
                                  </div>
                                </div>
                              </div>
                            )}

                          <button className="btnsw" onClick={detectSpikes}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                              <path strokeLinecap="round" strokeLinejoin="round" d="m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z" />
                            </svg>
                            <span className="tooltip-text">Evidenzia spyke</span>
                          </button>
                          <button className="btnsw" onClick={smoothSpikes}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M11.412 15.655 9.75 21.75l3.745-4.012M9.257 13.5H3.75l2.659-2.849m2.048-2.194L14.25 2.25 12 10.5h8.25l-4.707 5.043M8.457 8.457 3 3m5.457 5.457 7.086 7.086m0 0L21 21" />
                            </svg>
                            <span className="tooltip-text">Smooth spyke</span>
                          </button>
                          <button className="btnsw" onClick={() => setIsEditing(prev => !prev)}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                              <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                            </svg>
                            <span className="tooltip-text">Edit</span>
                          </button>
                          <button type="button" className="btnsw" onClick={resetta}>
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
                              </svg>
                              <span className="tooltip-text">Reset</span>
                          </button>
                          <button className="btnsw" onClick={() => navigate('/sHapp')}>
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                                  <path strokeLinecap="round" strokeLinejoin="round" d="m20.893 13.393-1.135-1.135a2.252 2.252 0 0 1-.421-.585l-1.08-2.16a.414.414 0 0 0-.663-.107.827.827 0 0 1-.812.21l-1.273-.363a.89.89 0 0 0-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.212.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 0 1-1.81 1.025 1.055 1.055 0 0 1-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.655-.261a2.25 2.25 0 0 1-1.383-2.46l.007-.042a2.25 2.25 0 0 1 .29-.787l.09-.15a2.25 2.25 0 0 1 2.37-1.048l1.178.236a1.125 1.125 0 0 0 1.302-.795l.208-.73a1.125 1.125 0 0 0-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 0 1-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 0 1-1.458-1.137l1.411-2.353a2.25 2.25 0 0 0 .286-.76m11.928 9.869A9 9 0 0 0 8.965 3.525m11.928 9.868A9 9 0 1 1 8.965 3.525" />
                                </svg>
                              <span className="tooltip-text">Vai al Geodatabase</span>
                          </button>
                        </div>
                       </div>
                        {/* TABELLA */}
                        <div className="table-containersw">
                          <table className="software-table">
                            <thead>
                              <tr>
                                <th>N</th>
                                <th>H</th>
                                <th>qc</th>
                                <th>fs</th>
                                <th>u2</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {tableData.map((row, i) => {
                                // evidenzia se qc o fs < 0.09
                                const highlight = (row.qc !== null && row.qc < 0.09) || (row.fs !== null && row.fs < 0.09 || spikeRows.includes(row.N));

                                return (
                                  <tr
                                    key={i}
                                    style={{
                                      backgroundColor: highlight ? "rgba(255,165,0,0.2)" : "transparent" // arancione chiaro
                                    }}
                                  >
                                    <td>{row.N}</td>
                                    <td>{isEditing ? (<input type="number" step="0.01" value={row.H ?? ""}
                                          onChange={(e) => { const newValue = parseFloat(e.target.value);
                                            setTableData(prev =>
                                              prev.map((r, idx) =>
                                                idx === i ? { ...r, H: isNaN(newValue) ? null : newValue } : r
                                              )
                                            );
                                          }}
                                          style={{ width: "50px", textAlign: "center" }}
                                        />
                                      ) : (
                                        row.H?.toFixed(2)
                                      )}
                                    </td>
                                    <td>{isEditing ? (<input type="number" step="0.01" value={row.qc ?? ""}
                                          onChange={(e) => { const newValue = parseFloat(e.target.value);
                                            setTableData(prev =>
                                              prev.map((r, idx) =>
                                                idx === i ? { ...r, qc: isNaN(newValue) ? null : newValue } : r
                                              )
                                            );
                                          }}
                                          style={{ width: "50px", textAlign: "center" }}
                                        />
                                      ) : (
                                        row.qc?.toFixed(2)
                                      )}
                                    </td>
                                    <td>{isEditing ? (<input type="number" step="0.01" value={row.fs ?? ""}
                                          onChange={(e) => { const newValue = parseFloat(e.target.value);
                                            setTableData(prev =>
                                              prev.map((r, idx) =>
                                                idx === i ? { ...r, fs: isNaN(newValue) ? null : newValue } : r
                                              )
                                            );
                                          }}
                                          style={{ width: "50px", textAlign: "center" }}
                                        />
                                      ) : (
                                        row.fs?.toFixed(2)
                                      )}
                                    </td>
                                    <td>{isEditing ? (<input type="number" step="0.01" value={row.u2 ?? ""}
                                          onChange={(e) => { const newValue = parseFloat(e.target.value);
                                            setTableData(prev =>
                                              prev.map((r, idx) =>
                                                idx === i ? { ...r,u2: isNaN(newValue) ? null : newValue } : r
                                              )
                                            );
                                          }}
                                          style={{ width: "50px", textAlign: "center" }}
                                        />
                                      ) : (
                                        row.u2?.toFixed(2)
                                      )}
                                    </td>
                                    <td>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor"
                                        className="icon"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => openDeleteModal(i)}
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          d="M12 9.75 14.25 12m0 0 2.25 2.25M14.25 12l2.25-2.25M14.25 12 12 14.25m-2.58 4.92-6.374-6.375a1.125 1.125 0 0 1 0-1.59L9.42 4.83c.21-.211.497-.33.795-.33H19.5a2.25 2.25 0 0 1 2.25 2.25v10.5a2.25 2.25 0 0 1-2.25 2.25h-9.284c-.298 0-.585-.119-.795-.33Z"
                                        />
                                      </svg>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>

                          {showDeleteModal && (
                              <div className="modal-overlay">
                                <div className="modal-content">
                                  <h3>Conferma cancellazione</h3>
                                  <p>Vuoi eliminare questa riga?</p>
                                  <div className="modal-buttons">
                                    <button onClick={confirmDelete} className="btnsw" style={{ backgroundColor: "red", color: "#fff" }}>
                                      Sì
                                    </button>
                                    <button onClick={() => setShowDeleteModal(false)} className="btnsw">
                                      No
                                    </button>
                                  </div>
                                </div>
                              </div>
                           )}

                        </div>
                  </div>
               );

            case 'anagrafica':
                return(
                  <div className="container-software">
                      <div className="container-select">
                        {/* NOME PROVA */}
                        <div className="field">
                          <label className="label">Nome prova</label>
                          <input
                            type="text"
                            className="input-text"
                            value={nomeProva}
                            onChange={(e) => setNomeProva(e.target.value)}
                          />
                        </div>

                        {/* COMMITTENTE */}
                        <div className="field">
                          <label className="label">Committente</label>
                          <input
                            type="text"
                            className="input-text"
                            value={committente}
                            onChange={(e) => setCommittente(e.target.value)}
                          />
                        </div>

                        {/* LOCALITÀ */}
                        <div className="field">
                          <label className="label">Località</label>
                          <input
                            type="text"
                            className="input-text"
                            value={localita}
                            onChange={(e) => setLocalita(e.target.value)}
                          />
                        </div>

                        {/* INDIRIZZO */}
                        <div className="field">
                          <label className="label">Indirizzo</label>
                          <input
                            type="text"
                            className="input-text"
                            value={indirizzo}
                            onChange={(e) => setIndirizzo(e.target.value)}
                          />
                        </div>
                      </div>
                  </div>
               );

            case 'analisi':
                return (

                    <div className="container-software">
                         <label className="label">Elaborazioni </label>
                         <div className="container-select">
                            <div className="toolbarsw">
                                <button className="btnsw" onClick={handleElabora}>
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                                          <path strokeLinecap="round" strokeLinejoin="round" d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.559.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.894.149c-.424.07-.764.383-.929.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.398.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.272-.806.108-1.204-.165-.397-.506-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894Z" />
                                          <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                      </svg>
                                      <span className="tooltip-text">Elabora prova</span>
                                </button>
                                <button className="btnsw" onClick={openStratModal}>
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                                          <path strokeLinecap="round" strokeLinejoin="round" d="M6.429 9.75 2.25 12l4.179 2.25m0-4.5 5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0 4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0-5.571 3-5.571-3" />
                                      </svg>
                                      <span className="tooltip-text">Elabora unità litotecniche</span>
                                </button>
                            </div>
                         </div>

                         {showStratModal && (
                              <div className="modal-overlay">
                                <div className="modal-content">
                                  <h3>Stratigrafia</h3>
                                  <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                                    <table>
                                      <thead>
                                        <tr>
                                          <th>#</th>
                                          <th title="Nome dello strato">Nome</th>
                                          <th title="Top dello strato in m da p.c.">Tetto</th>
                                          <th title="Base dello strato in m da p.c.">Letto</th>
                                          <th title="Tipologia del terreno: I=Icoerente, C=Coesivo, CI=Misto, TSA=Terreno superficiale alterato">Tipo</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {tableDatastrat.map((row, index) => (
                                          <tr key={index}>
                                            <td>{row.id}</td>
                                            <td>
                                              <input
                                                type="text"
                                                value={row.nome}
                                                onChange={(e) =>
                                                  updateCell(index, "nome", e.target.value)
                                                }
                                              />
                                            </td>
                                            <td>
                                              <input
                                                type="number"
                                                step="0.01"
                                                value={row.tetto}
                                                onChange={(e) =>
                                                  updateCell(index, "tetto", e.target.value)
                                                }
                                              />
                                            </td>
                                            <td>
                                              <input
                                                type="number"
                                                step="0.01"
                                                value={row.letto}
                                                onChange={(e) =>
                                                  updateCell(index, "letto", e.target.value)
                                                }
                                              />
                                            </td>
                                            <td>
                                              <select
                                                value={row.tipo}
                                                onChange={(e) =>
                                                  updateCell(index, "tipo", e.target.value)
                                                }
                                              >
                                                <option value="">--</option>
                                                <option value="I">I</option>
                                                <option value="C">C</option>
                                                <option value="CI">CI</option>
                                                <option value="TSA">TSA</option>
                                              </select>
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                  <div className="modal-buttons">
                                    <button onClick={() => setShowStratModal(false)} className="btnsw">
                                      Annulla
                                    </button>
                                    <button onClick={getstrat} className="btnsw">
                                      Conferma modello
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}

                         <label className="label">Analisi </label>
                         <div className="container-select">
                                <div className="toolbarsw">
                                    <button className="btnsw" onClick={openLiqueModal}>
                                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                                              <path strokeLinecap="round" strokeLinejoin="round" d="M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0 1 12 15a9.065 9.065 0 0 0-6.23-.693L5 14.5m14.8.8 1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0 1 12 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5" />
                                          </svg>

                                          <span className="tooltip-text">Verifica a liquefazione</span>
                                    </button>

                                    {showLiqueModal && (
                                      <div className="modal-overlay">
                                        <div className="modal-content">
                                          <h3>Parametri liquefazione</h3>
                                          <div className="param-row">

                                          {/* 🔹 INPUT PRINCIPALI */}
                                            <label>Mw max</label>
                                            <input
                                              type="number"
                                              step="0.1"
                                              value={mw}
                                              onChange={(e) => setMw(e.target.value)}
                                            />

                                            <label>Acc max / g</label>
                                            <input
                                              type="number"
                                              step="0.01"
                                              value={accMax}
                                              onChange={(e) => setAccMax(e.target.value)}
                                            />
                                          </div>

                                          <div className="param-row">
                                            <label>Prof. max</label>
                                            <input
                                              type="number"
                                              step="0.1"
                                              value={profMax}
                                              onChange={(e) => setProfMax(e.target.value)}
                                            />

                                            
                                          </div>

                                          {/* 🔹 METODO */}
                                          <div className="param-row">
                                            <label>Metodo</label>
                                            <select
                                              value={metodo}
                                              onChange={(e) => setMetodo(e.target.value)}
                                            >
                                              <option value="">--</option>
                                              <option value="1">Boulanger & Idriss (2014)</option>
                                              <option value="2">Robertson & Wride (1998)</option>
                                            </select>
                                          </div>

                                          {/* 🔹 CSR */}
                                          <input
                                              type="file"
                                              accept=".txt"
                                              id="csrFileInput"
                                              style={{ display: "none" }}
                                              onChange={handleCSRFile}
                                            />
                                          <button
                                              onClick={() => document.getElementById("csrFileInput").click()}
                                              className="btnsw"
                                            >
                                              Carica CSR
                                              <span className="tooltip-text">
                                                Carica file CSR personalizzato <br />
                                                formato: val,h <br />
                                                no header
                                              </span>
                                           </button>

                                           <div className="param-row">
                                              <label>Verifica cedimento (Free Field)</label>
                                              <select
                                                value={verificaCedimento}
                                                onChange={(e) => setVerificaCedimento(e.target.value)}
                                              >
                                                <option value="no">No</option>
                                                <option value="si">Sì</option>

                                              </select>
                                            </div>

                                          {/* 🔹 BOTTONI */}
                                          <div className="modal-buttons">
                                            <button
                                              onClick={() => setShowLiqueModal(false)}
                                              className="btnsw"
                                            >
                                              Annulla
                                            </button>

                                            <button
                                              onClick={handleConfirm}
                                              className="btnsw"
                                            >
                                              Conferma
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    )}

                                    <button className="btnsw" onClick={() => {toast("In fase di sviluppo!");}}>
                                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                                              <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5m.75-9 3-3 2.148 2.148A12.061 12.061 0 0 1 16.5 7.605" />
                                          </svg>
                                          <span className="tooltip-text">Test dissipazione</span>
                                    </button>
                                </div>
                         </div>
                    </div>
               );

            case 'archivia':
                return (
                <div className="container-software">
                    <label className="label">Database </label>
                     <div className="container-select">
                            <div className="toolbarsw">
                                <button className="btnsw" onClick={toDB}>
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                                          <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
                                      </svg>
                                      <span className="tooltip-text">Archivia</span>
                                </button>
                                <button className="btnsw" onClick={() => navigate('/sHapp')}>
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                                          <path strokeLinecap="round" strokeLinejoin="round" d="m20.893 13.393-1.135-1.135a2.252 2.252 0 0 1-.421-.585l-1.08-2.16a.414.414 0 0 0-.663-.107.827.827 0 0 1-.812.21l-1.273-.363a.89.89 0 0 0-.738 1.595l.587.39c.59.395.674 1.23.172 1.732l-.2.2c-.212.212-.33.498-.33.796v.41c0 .409-.11.809-.32 1.158l-1.315 2.191a2.11 2.11 0 0 1-1.81 1.025 1.055 1.055 0 0 1-1.055-1.055v-1.172c0-.92-.56-1.747-1.414-2.089l-.655-.261a2.25 2.25 0 0 1-1.383-2.46l.007-.042a2.25 2.25 0 0 1 .29-.787l.09-.15a2.25 2.25 0 0 1 2.37-1.048l1.178.236a1.125 1.125 0 0 0 1.302-.795l.208-.73a1.125 1.125 0 0 0-.578-1.315l-.665-.332-.091.091a2.25 2.25 0 0 1-1.591.659h-.18c-.249 0-.487.1-.662.274a.931.931 0 0 1-1.458-1.137l1.411-2.353a2.25 2.25 0 0 0 .286-.76m11.928 9.869A9 9 0 0 0 8.965 3.525m11.928 9.868A9 9 0 1 1 8.965 3.525" />
                                        </svg>
                                      <span className="tooltip-text">Vai al Geodatabase</span>
                                </button>
                            </div>
                     </div>
                     <div className="container-software">

                             <label className="label">Id </label>
                             <div className="container-select">
                                  <div className="field">
                                    <input
                                      type="text"
                                      className="input-text"
                                      value={idgeom || ""}    // <-- prende lo stato
                                      readOnly
                                      placeholder="-"
                                    />
                             </div>
                             </div>

                             <label className="label">Note </label>
                             <div className="container-select">
                                  <div className="field">
                                    <input
                                      type="text"
                                      className="input-text"
                                      value={note || ""}   // <-- prende lo stato
                                      onChange={(e) => setnote(e.target.value)}
                                      placeholder="-"
                                    />
                             </div>
                             </div>

                             <label className="label">Seleziona Team </label>
                             <div className="container-select"style={{  heigth: "600px", overflow: "visible" }}>
                             <div className="field">
                                   <select className="layout-select" value={selectedTeam} onChange={e => setSelectedTeam(e.target.value)}>
                                      <option value="">Nessuno</option>
                                      {teams.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
                                    </select>
                             </div>
                             </div>

                             <label className="label">Coordinate </label>
                             <div className="container-select">
                                  <div className="field">
                                    <input
                                      type="text"
                                      className="input-text"
                                      value={coordinate || ""}   // <-- prende lo stato
                                      readOnly
                                      placeholder="-"
                                    />
                             </div>
                             </div>

                             <label className="label">Seleziona </label>
                             <div className="container-select"style={{  heigth: "600px", overflow: "visible" }}>
                             <div className="toolbarsw">
                                <div className="field">
                                    <select value={selectedProject} onChange={handleProjectChange} className="layout-select">
                                        <option value="">Select a Project</option>
                                        {projects.map((p, i) => (
                                          <option key={i} value={p}>{p}</option>
                                        ))}
                                   </select>
                                </div>
                                <button onClick={() => setIsMapClickActive(prev => !prev)} className="btnsw">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="icon">
                                          <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                        </svg>
                                    <span className="tooltip-text">Aggiungi manualmente</span>
                                </button>
                            </div>
                            </div>

                    </div>
                    <MapComponent_sw ref={mapRef}  onSendCoordinate={handleReceiveCoordinate} mapClickActive={isMapClickActive}/>
                   </div>
               );

            case 'avanzate':
                return (
                    <div className="container-avanzate">
                        <div className="container-select">
                                    {(tipoProva === "CPTU" || tipoProva === "CPTE")  && (
                                        <div className="field">
                                            <label className="label">Litologia</label>
                                            <select className="layout-select" value={ulitologia} onChange={(e) => setuLitologia(e.target.value)}>
                                                <option value="SBTn">SBTn</option>
                                                <option value="SBT">SBT</option>
                                            </select>
                                            <label className="label">Peso unitario terreno</label>
                                            <select className="layout-select" value={ugamma} onChange={(e) => setugamma(e.target.value)}>
                                                <option value="SBTg">SBT Robertson (1986)</option>
                                                <option value="ro10">γ/γw Robertson (2010)</option>
                                                <option value="ma10">γt Mayne (2010)</option>
                                            </select>
                                            <label className="label">Angolo di attrito</label>
                                            <select className="layout-select" value={uphi} onChange={(e) => setuphi(e.target.value)}>
                                                <option value="km90">Kuhlawy & Mayne (1990)</option>
                                                <option value="uz2013">Uzielli (2013)</option>
                                            </select>
                                            <label className="label">Fattore di punta Nkt</label>
                                            <select className="layout-select" value={ufap} onChange={(e) => setfap(e.target.value)}>
                                                <option value="14">14</option>
                                                <option value="15">15</option>
                                                <option value="16">16</option>
                                                <option value="17">17</option>
                                                <option value="18">18</option>
                                            </select>
                                        </div>
                                    )}

                                    {tipoProva === "CPT" &&
                                        <div className="field">
                                            <label className="label">Litologia</label>
                                            <select className="layout-select" value={tmlitologia} onChange={(e) => settmLitologia(e.target.value)}>
                                                <option value="s78">Schmertmann (1978)</option>
                                                <option value="bg65">Begemann (1965)</option>
                                            </select>
                                            <label className="label">Peso unitario terreno</label>
                                            <select className="layout-select" value={tmgamma} onChange={(e) => settmgamma(e.target.value)}>
                                                <option value="ro10">γ/γw Robertson (2010)</option>
                                                <option value="ma10">γt Mayne (2010)</option>
                                            </select>
                                            <br />
                                            <label className="label">Terreni incoerenti</label>
                                            <label className="label">Angolo di attrito eff.</label>
                                            <select className="layout-select" value={tmphi} onChange={(e) => settmphi(e.target.value)}>
                                                <option value="beer">De Beer (1965-1967)</option>
                                                <option value="dur75">Durungunoglu & Mitchell (1975)</option>
                                                <option value="mey51">Meyerhof (1951)</option>
                                                <option value="caq">Caquot </option>
                                                <option value="rbc90">Robertson & Campanella (1990)</option>
                                            </select>
                                            <label className="label">Modulo edometrico</label>
                                            <select className="layout-select" value={tmo} onChange={(e) => settmo(e.target.value)}>
                                                <option value="mg75">Mitchell & Gardner (1975)</option>
                                                <option value="rbc90">Robertson & Campanella</option>
                                            </select>
                                            <label className="label">Modulo di young</label>
                                            <select className="layout-select" value={tmyo} onChange={(e) => settmyo(e.target.value)}>
                                                <option value="s78">Schmertmann (1978)</option>
                                                <option value="rel">Da moduli elastici</option>
                                            </select>
                                            <label className="label">Densità relativa</label>
                                            <select className="layout-select" value={tmdr} onChange={(e) => settmdr(e.target.value)}>
                                                <option value="la83">Lancellotta (1983)</option>
                                                <option value="s78">Shcmertmann</option>
                                            </select>
                                            <br />
                                            <label className="label">Terreni coesivi</label>
                                            <label className="label">Coesione non drenata</label>
                                            <select className="layout-select" value={tmcu} onChange={(e) => settmcu(e.target.value)}>
                                                <option value="mk88">Mayne & Kemper (1988)</option>
                                                <option value="lrp77">Lunne, Roberston & Powell (1977)</option>
                                                <option value="ltk81">Lunne T. & Kleven A. (1981)</option>
                                                <option value="kj78">Kjekstad (1978)</option>
                                                <option value="bg65">Begemann</option>
                                            </select>
                                            <label className="label">OCR</label>
                                            <select className="layout-select" value={tmocr} onChange={(e) => settmocr(e.target.value)}>
                                                <option value="m91">Mayne (1991)</option>
                                                <option value="cm1996">Chen & Mayne (1996)</option>
                                                <option value="ldf">Ladd & Foot</option>
                                            </select>
                                            <label className="label">Mod. di def. non dren.</label>
                                            <select className="layout-select" value={tmdf} onChange={(e) => settmdf(e.target.value)}>
                                                <option value="v">Viaggiani</option>
                                                <option value="rel">Da moduli elastici</option>
                                            </select>
                                            <label className="label">Modulo edometrico</label>
                                            <select className="layout-select" value={tmoc} onChange={(e) => settmoc(e.target.value)}>
                                                <option value="mg75">Mitchell & Gardner (1975)</option>
                                                <option value="km90">Kuhlaway & Mayne (1990)</option>
                                            </select>
                                        </div>
                                    }
                        </div>
                  </div>
               );
            default:
                return null;
        }
    };


    return (
            <div className="Principal">


                {/* Spinner / overlay */}
                    {loadingelab && (
                      <div className="spinner-overlay">
                        <div className="spinner"></div>
                        <p>Elaborazione in corso...</p>
                      </div>
                    )}

                <div className="layoutapp">
                    <div className="infotab" ref={infotabRef} style={{ width: `${infotabWidth}px` }}>
                        <div className="Title-sh">Static probe</div>
                        <hr className="divider" />
                        <div className="menu">
                            <ul>

                                <li
                                    onClick={() => setSelectedMenu('anagrafica')}
                                    className={selectedMenu === 'anagrafica' ? 'active' : ''}
                                >
                                    Anagrafica
                                </li>
                                <li
                                    onClick={() => setSelectedMenu('input')}
                                    className={selectedMenu === 'input' ? 'active' : ''}
                                >
                                    Input
                                </li>
                                <li
                                    onClick={() => setSelectedMenu('analisi')}
                                    className={selectedMenu === 'analisi' ? 'active' : ''}
                                >
                                    Analisi
                                </li>
                                <li
                                    onClick={() => setSelectedMenu('archivia')}
                                    className={selectedMenu === 'archivia' ? 'active' : ''}
                                >
                                    Archivia
                                </li>
                                <li
                                    onClick={() => setSelectedMenu('avanzate')}
                                    className={selectedMenu === 'avanzate' ? 'active' : ''}
                                >
                                    Imp. Avanzate
                                </li>
                            </ul>
                        </div>
                        {renderContent()}

                    </div>
                    <div className="App">
                        <div className="cpt-layout">
                          {/* Main content: report + secondary affiancati */}
                          <div className="cpt-main">
                              <div className="cpt-single">
                                {/* MENU SWITCH */}
                                <div className="cpt-tabs">
                                  <button className={activePanel === "report" ? "active" : ""} onClick={() => setActivePanel("report")}>
                                    Report Prova
                                  </button>
                                  <button className={activePanel === "iplreport" ? "active" : ""} onClick={() => setActivePanel("iplreport")}>
                                    Report IPL
                                  </button>
                                </div>
                                {/* CONTENUTO */}
                                <div className="section-content">
                                  {/* REPORT (iframe sempre montato) */}
                                  <div style={{ display: activePanel === "report" ? "block" : "none", height: "100%" }}>
                                    <iframe
                                      id="reportFrame"
                                      style={{ width: "100%", height: "100%", border: "none" }}
                                    />
                                  </div>

                                  {/* SECONDARIO */}
                                  <div style={{ display: activePanel === "iplreport" ? "block" : "none", height: "100%" }}>
                                    <iframe
                                      id="reportFrameipl"
                                      style={{ width: "100%", height: "100%", border: "none" }}
                                    />
                                  </div>

                                </div>

                              </div>
                            </div>


                          {/* Tabella inferiore: 40% altezza */}
                          <div className="cpt-table" id="tableContainer">
                            <div className="table-content">
                                {tableOut && (() => {
                                  const hiddenColumns = ["Bq", "Qcfs"];
                                  const columns = tableConfig[tipoProva].columns.filter(
                                      col => !hiddenColumns.includes(col.key)
                                    );
                                  const rows = buildRows(tableOut);
                                  const format = (v, key) => {
                                      if (v == null) return "";
                                      if (key === "KSBT" || key === "K") {
                                        return Number(v).toExponential(2).replace("e", "E");
                                      }
                                      // Se è un numero lo formatto, altrimenti lo lascio come stringa
                                      return typeof v === "number" ? v.toFixed(2) : String(v);
                                    };
                                  return (
                                    <table>
                                      <thead>
                                        <tr>
                                          {columns.map(col => (
                                            <th key={col.key}>{col.label}</th>
                                          ))}
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {rows.map((row, i) => (
                                          <tr key={i}>
                                            {columns.map(col => (
                                              <td key={col.key}>
                                                {format(row[col.key], col.key)}
                                              </td>
                                            ))}
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  );
                                })()}
                            </div>

                          </div>


                        </div>


                        <div
                            className="resize-handle"
                            onMouseDown={handleMouseDown}
                        />


                    </div>
                </div>
            </div>
        );
    }

export default CptElabPanel;
